// Copyright (c) 2016 Deere & Company

import * as productActions from '../../actions-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';

const actions = {
    ...productActions,
    ...userActions
};

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const updateTransferRecommendationFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const toggleTransferRecommendationFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateFacetsOnLoad = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const resetTransferRecommendationFacet = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.allowedDealers
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.allowedDealers
            }
        },
        requestedDateRange: {
            $set: getDefaultState().requestedDateRange
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_TRANSFER_RECOMMENDATION_FACETS]: resetTransferRecommendationFacet,
        [actions.TOGGLE_TRANSFER_RECOMMENDATION_FACET_ITEMS]: toggleTransferRecommendationFacetItems,
        [actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEMS_ON_LOAD]: updateFacetsOnLoad,
        [actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEM]: updateTransferRecommendationFacetItem,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/reducers/facets.js